import { useEffect } from 'react';

const useOnUnloadScreen = (onUnloadScreen, alertMessage = '') => {
  function onExitFn(event) {
    event.preventDefault();

    if (onUnloadScreen) {
      onUnloadScreen();
    }

    return alertMessage;
  }

  useEffect(() => {
    window.onbeforeunload = onExitFn;
    window.onunload = onExitFn;

    return () => {
      window.onbeforeunload = null;
      window.onunload = null;
    };
  }, []);
};

export { useOnUnloadScreen };
